module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_yamori01-75e165dca98f0c622b071ae8a10b8722.jpg";